<template>
  <div class="index">
    <div class="nav1">
      <div class="tit1">岗位分析模型</div>
    </div>
    <div class="nav2">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="openAdd">添加</el-button>
      <span class="tip">启用的配置按排序从高到低依次使用，调用失败自动降级到下一个，最后降级到 yml 配置</span>
      <el-table :data="tableData" style="margin-top: 16px" v-loading="loading">
        <el-table-column prop="name" label="名称" min-width="120"></el-table-column>
        <el-table-column label="厂商" width="90">
          <template slot-scope="scope">{{ providerLabel(scope.row.provider) }}</template>
        </el-table-column>
        <el-table-column prop="url" label="URL" min-width="260" show-overflow-tooltip></el-table-column>
        <el-table-column prop="model" label="模型" min-width="160"></el-table-column>
        <el-table-column label="思考" width="70">
          <template slot-scope="scope">{{ scope.row.thinking == 1 ? "开" : "关" }}</template>
        </el-table-column>
        <el-table-column prop="sort_num" label="排序" width="70"></el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button type="text" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" :loading="checkingId === scope.row.id" @click="check(scope.row)">可用性检查</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :title="form.id ? '编辑模型配置' : '添加模型配置'" :visible.sync="visible" width="560px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="名称">
          <el-input v-model="form.name" size="small" placeholder="如 千问 flash"></el-input>
        </el-form-item>
        <el-form-item label="厂商">
          <el-select v-model="form.provider" size="small" @change="onProviderChange">
            <el-option v-for="p in providers" :key="p.value" :label="p.label" :value="p.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="URL">
          <el-input v-model="form.url" size="small"></el-input>
        </el-form-item>
        <el-form-item label="Token">
          <el-input v-model="form.token" size="small" show-password autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="模型">
          <el-input v-model="form.model" size="small" :placeholder="modelPlaceholder"></el-input>
        </el-form-item>
        <el-form-item label="思考模式">
          <el-switch v-model="form.thinking" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort_num" size="small" :step="1"></el-input-number>
          <span class="tip">数值越大越优先</span>
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="visible = false">取消</el-button>
        <el-button size="small" type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="可用性检查" :visible.sync="checkVisible" width="640px">
      <div v-if="checkResult">
        <div class="check-head">
          <el-tag :type="checkResult.ok ? 'success' : 'danger'">{{ checkResult.ok ? "可用" : "不可用" }}</el-tag>
          <span>耗时 {{ checkResult.costMs }} ms</span>
          <span>HTTP {{ checkResult.httpStatus == null ? "-" : checkResult.httpStatus }}</span>
        </div>
        <el-descriptions :column="2" size="small" border>
          <el-descriptions-item label="名称">{{ checkResult.name }}</el-descriptions-item>
          <el-descriptions-item label="厂商">{{ providerLabel(checkResult.provider) }}</el-descriptions-item>
          <el-descriptions-item label="模型">{{ checkResult.model }}</el-descriptions-item>
          <el-descriptions-item label="思考模式">{{ checkResult.thinking == 1 ? "开" : "关" }}</el-descriptions-item>
          <template v-if="checkResult.ok && checkResult.usage">
            <el-descriptions-item label="输入 tokens">{{ checkResult.usage.prompt_tokens }}</el-descriptions-item>
            <el-descriptions-item label="输出 tokens">{{ checkResult.usage.completion_tokens }}</el-descriptions-item>
            <el-descriptions-item label="合计 tokens">{{ checkResult.usage.total_tokens }}</el-descriptions-item>
          </template>
        </el-descriptions>
        <div class="check-label">{{ checkResult.ok ? "模型回复" : "错误信息" }}</div>
        <pre class="check-pre">{{ checkResult.ok ? checkResult.content : checkResult.error }}</pre>
      </div>
      <span slot="footer">
        <el-button size="small" @click="checkVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const PROVIDERS = [
  {
    value: "volcano",
    label: "火山",
    url: "https://ark.cn-beijing.volces.com/api/v3/chat/completions",
    model: "doubao-seed-2-1-lite-260915"
  },
  {
    value: "qwen",
    label: "千问",
    url: "https://dashscope.aliyuncs.com/compatible-mode/v1/chat/completions",
    model: "qwen3.8-flash"
  }
];

function toInt(v) {
  if (v === true) return 1;
  if (v === false || v === null || v === undefined || v === "") return 0;
  return Number(v);
}

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      providers: PROVIDERS,
      visible: false,
      form: this.emptyForm(),
      checkingId: null,
      checkVisible: false,
      checkResult: null
    };
  },
  computed: {
    modelPlaceholder() {
      const p = PROVIDERS.find(item => item.value === this.form.provider);
      return p ? "如 " + p.model : "";
    }
  },
  created() {
    this.getData();
  },
  methods: {
    emptyForm() {
      return {
        id: null,
        name: "",
        provider: "qwen",
        url: PROVIDERS[1].url,
        token: "",
        model: "",
        thinking: 1,
        sort_num: 0,
        status: 1
      };
    },
    providerLabel(value) {
      const p = PROVIDERS.find(item => item.value === value);
      return p ? p.label : value;
    },
    async getData() {
      this.loading = true;
      const res = await this.$api.crudselectListByMap({
        page: 1,
        pagesize: 500,
        table: "ai_model_config",
        params: {}
      });
      const rows = (res && res.data && res.data.data) || [];
      rows.forEach(row => {
        row.thinking = toInt(row.thinking);
        row.status = toInt(row.status);
        row.sort_num = toInt(row.sort_num);
      });
      rows.sort((a, b) => (b.sort_num - a.sort_num) || (Number(a.id) - Number(b.id)));
      this.tableData = rows;
      this.loading = false;
    },
    onProviderChange(value) {
      const p = PROVIDERS.find(item => item.value === value);
      if (p) {
        this.form.url = p.url;
      }
    },
    openAdd() {
      this.form = this.emptyForm();
      this.visible = true;
    },
    openEdit(row) {
      this.form = {
        id: row.id,
        name: row.name,
        provider: row.provider,
        url: row.url,
        token: row.token,
        model: row.model,
        thinking: row.thinking,
        sort_num: row.sort_num,
        status: row.status
      };
      this.visible = true;
    },
    async save() {
      const f = this.form;
      if (!f.name || !f.provider || !f.url || !f.token || !f.model) {
        this.$message.error("名称、厂商、URL、Token、模型均为必填");
        return;
      }
      const values = {
        name: f.name.trim(),
        provider: f.provider,
        url: f.url.trim(),
        token: f.token.trim(),
        model: f.model.trim(),
        thinking: f.thinking,
        sort_num: Number(f.sort_num) || 0,
        status: f.status
      };
      const res = f.id
        ? await this.$api.crudupdatebyid({ table: "ai_model_config", id: f.id, values })
        : await this.$api.crudInsert({ table: "ai_model_config", values });
      if (res.data && res.data.result == 1) {
        this.$message.success("保存成功");
        this.visible = false;
        this.getData();
      } else {
        this.$message.error((res.data && res.data.msg) || "保存失败");
      }
    },
    async changeStatus(row) {
      const res = await this.$api.crudupdatebyid({
        table: "ai_model_config",
        id: row.id,
        values: { status: row.status }
      });
      if (res.data && res.data.result == 1) {
        this.$message.success(row.status == 1 ? "已启用" : "已停用");
      } else {
        this.$message.error((res.data && res.data.msg) || "操作失败");
      }
      this.getData();
    },
    async check(row) {
      this.checkingId = row.id;
      try {
        const res = await this.$api.aimodelconfig_check({ id: row.id });
        if (res && res.result == 1) {
          this.checkResult = res.data;
          this.checkVisible = true;
        } else {
          this.$message.error((res && res.msg) || "检查失败");
        }
      } finally {
        this.checkingId = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav1 {
  margin: 0 -18px;
  background-color: #fff;
  padding: 20px 32px 0 40px;
  .tit1 {
    color: #17233d;
    font-weight: 500;
    font-size: 20px;
  }
}
.nav2 {
  background: #fff;
  margin: 16px 0;
  padding: 20px;
}
.tip {
  margin-left: 12px;
  color: #909399;
  font-size: 12px;
}
.check-head {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}
.check-label {
  margin: 12px 0 6px;
  font-weight: 500;
}
.check-pre {
  max-height: 300px;
  overflow: auto;
  background: #f5f7fa;
  padding: 10px;
  white-space: pre-wrap;
  word-break: break-all;
  margin: 0;
}
</style>
